import React, { ReactNode } from 'react'

import { Icon } from '../Icon'
import { Typography } from '../Typography'

export type EmptyStateProps = {
  variant?: 'consumer' | 'retailer' | 'retailer-small' | 'orders'
  size?: 'small' | 'default'
  height?: string
  width?: string
  color?: string
  extraGap?: string
  children?: ReactNode
}

export default function EmptyState({
  variant,
  size,
  height,
  width,
  color = 'var(--gray400)',
  extraGap = '0px',
  children,
}: EmptyStateProps) {
  variant = variant ?? 'retailer'

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: variant === 'orders' ? '30px' : undefined,
      }}
    >
      <Icon
        color={color ?? 'var(--gray400)'}
        type={
          variant === 'consumer'
            ? 'EMPTY_STATE_CONSUMER'
            : variant === 'orders'
              ? 'ORDERS'
              : 'EMPTY_STATE_RETAILER'
        }
        height={
          variant === 'orders'
            ? '40px'
            : height || (variant !== 'retailer-small' ? '150px' : '80px')
        }
        width={
          variant === 'orders'
            ? '40px'
            : width || (variant !== 'retailer-small' ? '150px' : '80px')
        }
        viewBox={variant !== 'orders' ? '0 0 1181 1181' : undefined}
      />
      <Typography
        variant={size === 'small' ? 'body' : 'h2'}
        style={{
          color:
            variant === 'orders' ? 'var(--text-primary)' : `var(--${color})`,
          marginTop: extraGap,
          marginBottom: extraGap,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '30px',
        }}
      >
        {children ??
          (variant === 'orders' ? 'No orders found.' : 'Nothing here')}
      </Typography>
    </div>
  )
}
